import _defineProperty from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["name", "min", "max", "step", "orientation", "disabled", "minStepsBetweenThumbs", "defaultValue", "value", "onValueChange"],
    _excluded2 = ["min", "max", "dir", "onSlideStart", "onSlideMove", "onStepKeyDown"],
    _excluded3 = ["min", "max", "onSlideStart", "onSlideMove", "onStepKeyDown"],
    _excluded4 = ["__scopeSlider", "onSlideStart", "onSlideMove", "onSlideEnd", "onHomeKeyDown", "onEndKeyDown", "onStepKeyDown"],
    _excluded5 = ["__scopeSlider"],
    _excluded6 = ["__scopeSlider"],
    _excluded7 = ["__scopeSlider", "index"],
    _excluded8 = ["value"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createCollection as e } from "@radix-ui/react-collection";
import { Primitive as t } from "@radix-ui/react-primitive";
import { useSize as n } from "@radix-ui/react-use-size";
import { usePrevious as r } from "@radix-ui/react-use-previous";
import { useDirection as o } from "@radix-ui/react-use-direction";
import { useControllableState as i } from "@radix-ui/react-use-controllable-state";
import { createContextScope as a } from "@radix-ui/react-context";
import { useComposedRefs as l } from "@radix-ui/react-compose-refs";
import { composeEventHandlers as d } from "@radix-ui/primitive";
import { clamp as s } from "@radix-ui/number";
import * as u from "react";
import c from "@babel/runtime/helpers/esm/extends";

var m = ["PageUp", "PageDown"],
    f = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"],
    p = {
  ltr: ["ArrowDown", "Home", "ArrowLeft", "PageDown"],
  rtl: ["ArrowDown", "Home", "ArrowRight", "PageDown"]
},
    _e = e("Slider"),
    _e2 = _slicedToArray(_e, 3),
    S = _e2[0],
    h = _e2[1],
    v = _e2[2],
    _a = a("Slider", [v]),
    _a2 = _slicedToArray(_a, 2),
    w = _a2[0],
    g = _a2[1];

export { g as createSliderScope };

var _w = w("Slider"),
    _w2 = _slicedToArray(_w, 2),
    x = _w2[0],
    b = _w2[1];

export var Slider = /*#__PURE__*/u.forwardRef(function (e, t) {
  var n = e.name,
      _e$min = e.min,
      r = _e$min === void 0 ? 0 : _e$min,
      _e$max = e.max,
      o = _e$max === void 0 ? 100 : _e$max,
      _e$step = e.step,
      a = _e$step === void 0 ? 1 : _e$step,
      _e$orientation = e.orientation,
      d = _e$orientation === void 0 ? "horizontal" : _e$orientation,
      _e$disabled = e.disabled,
      p = _e$disabled === void 0 ? !1 : _e$disabled,
      _e$minStepsBetweenThu = e.minStepsBetweenThumbs,
      h = _e$minStepsBetweenThu === void 0 ? 0 : _e$minStepsBetweenThu,
      _e$defaultValue = e.defaultValue,
      v = _e$defaultValue === void 0 ? [r] : _e$defaultValue,
      w = e.value,
      _e$onValueChange = e.onValueChange,
      g = _e$onValueChange === void 0 ? function () {} : _e$onValueChange,
      b = _objectWithoutProperties(e, _excluded),
      _u$useState = u.useState(null),
      _u$useState2 = _slicedToArray(_u$useState, 2),
      E = _u$useState2[0],
      y = _u$useState2[1],
      _ = l(t, function (e) {
    return y(e);
  }),
      M = u.useRef(new Set()),
      K = u.useRef(0),
      T = "horizontal" === d,
      k = !E || Boolean(E.closest("form")),
      C = T ? R : D,
      _i = i({
    prop: w,
    defaultProp: v,
    onChange: function onChange(e) {
      var t;
      null === (t = _toConsumableArray(M.current)[K.current]) || void 0 === t || t.focus(), g(e);
    }
  }),
      _i2 = _slicedToArray(_i, 2),
      _i2$ = _i2[0],
      I = _i2$ === void 0 ? [] : _i2$,
      z = _i2[1];

  function A(e, t) {
    var n = function (e) {
      return (String(e).split(".")[1] || "").length;
    }(a),
        i = function (e, t) {
      var n = Math.pow(10, t);
      return Math.round(e * n) / n;
    }(Math.round((e - r) / a) * a + r, n),
        l = s(i, [r, o]);

    z(function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var n = function () {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var t = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;

        var r = _toConsumableArray(e);

        return r[n] = t, r.sort(function (e, t) {
          return e - t;
        });
      }(e, l, t);

      return function (e, t) {
        if (t > 0) {
          var _n = function (e) {
            return e.slice(0, -1).map(function (t, n) {
              return e[n + 1] - t;
            });
          }(e);

          return Math.min.apply(Math, _toConsumableArray(_n)) >= t;
        }

        return !0;
      }(n, h * a) ? (K.current = n.indexOf(l), String(n) === String(e) ? e : n) : e;
    });
  }
  /*#__PURE__*/


  return u.createElement(x, {
    scope: e.__scopeSlider,
    disabled: p,
    min: r,
    max: o,
    valueIndexToChangeRef: K,
    thumbs: M.current,
    values: I,
    orientation: d
  }, /*#__PURE__*/u.createElement(S.Provider, {
    scope: e.__scopeSlider
  }, /*#__PURE__*/u.createElement(S.Slot, {
    scope: e.__scopeSlider
  }, /*#__PURE__*/u.createElement(C, c({
    "aria-disabled": p,
    "data-disabled": p ? "" : void 0
  }, b, {
    ref: _,
    min: r,
    max: o,
    onSlideStart: p ? void 0 : function (e) {
      A(e, function (e, t) {
        if (1 === e.length) return 0;
        var n = e.map(function (e) {
          return Math.abs(e - t);
        }),
            r = Math.min.apply(Math, _toConsumableArray(n));
        return n.indexOf(r);
      }(I, e));
    },
    onSlideMove: p ? void 0 : function (e) {
      A(e, K.current);
    },
    onHomeKeyDown: function onHomeKeyDown() {
      return !p && A(r, 0);
    },
    onEndKeyDown: function onEndKeyDown() {
      return !p && A(o, I.length - 1);
    },
    onStepKeyDown: function onStepKeyDown(_ref) {
      var e = _ref.event,
          t = _ref.direction;

      if (!p) {
        var _n2 = m.includes(e.key) || e.shiftKey && f.includes(e.key) ? 10 : 1,
            _r = K.current;

        A(I[_r] + a * _n2 * t, _r);
      }
    }
  })))), k && I.map(function (e, t) {
    return /*#__PURE__*/u.createElement(P, {
      key: t,
      name: n ? n + (I.length > 1 ? "[]" : "") : void 0,
      value: e
    });
  }));
});
/*#__PURE__*/

var _w3 = w("Slider", {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}),
    _w4 = _slicedToArray(_w3, 2),
    E = _w4[0],
    y = _w4[1],
    R = /*#__PURE__*/u.forwardRef(function (e, t) {
  var n = e.min,
      r = e.max,
      i = e.dir,
      a = e.onSlideStart,
      d = e.onSlideMove,
      s = e.onStepKeyDown,
      m = _objectWithoutProperties(e, _excluded2),
      _u$useState3 = u.useState(null),
      _u$useState4 = _slicedToArray(_u$useState3, 2),
      f = _u$useState4[0],
      S = _u$useState4[1],
      h = l(t, function (e) {
    return S(e);
  }),
      v = u.useRef(),
      w = o(f, i),
      g = "ltr" === w;

  function x(e) {
    var t = v.current || f.getBoundingClientRect(),
        o = T([0, t.width], g ? [n, r] : [r, n]);
    return v.current = t, o(e - t.left);
  }
  /*#__PURE__*/


  /*#__PURE__*/
  return u.createElement(E, {
    scope: e.__scopeSlider,
    startEdge: g ? "left" : "right",
    endEdge: g ? "right" : "left",
    direction: g ? 1 : -1,
    size: "width"
  }, /*#__PURE__*/u.createElement(_, c({
    "data-orientation": "horizontal"
  }, m, {
    ref: h,
    style: _objectSpread(_objectSpread({}, m.style), {}, {
      "--radix-slider-thumb-transform": "translateX(-50%)"
    }),
    onSlideStart: function onSlideStart(e) {
      var t = x(e.clientX);
      null == a || a(t);
    },
    onSlideMove: function onSlideMove(e) {
      var t = x(e.clientX);
      null == d || d(t);
    },
    onSlideEnd: function onSlideEnd() {
      return v.current = void 0;
    },
    onStepKeyDown: function onStepKeyDown(e) {
      var t = p[w].includes(e.key);
      null == s || s({
        event: e,
        direction: t ? -1 : 1
      });
    }
  })));
}),
    D = /*#__PURE__*/u.forwardRef(function (e, t) {
  var n = e.min,
      r = e.max,
      o = e.onSlideStart,
      i = e.onSlideMove,
      a = e.onStepKeyDown,
      d = _objectWithoutProperties(e, _excluded3),
      s = u.useRef(null),
      m = l(t, s),
      f = u.useRef();

  function S(e) {
    var t = f.current || s.current.getBoundingClientRect(),
        o = T([0, t.height], [r, n]);
    return f.current = t, o(e - t.top);
  }
  /*#__PURE__*/


  /*#__PURE__*/
  return u.createElement(E, {
    scope: e.__scopeSlider,
    startEdge: "bottom",
    endEdge: "top",
    size: "height",
    direction: 1
  }, /*#__PURE__*/u.createElement(_, c({
    "data-orientation": "vertical"
  }, d, {
    ref: m,
    style: _objectSpread(_objectSpread({}, d.style), {}, {
      "--radix-slider-thumb-transform": "translateY(50%)"
    }),
    onSlideStart: function onSlideStart(e) {
      var t = S(e.clientY);
      null == o || o(t);
    },
    onSlideMove: function onSlideMove(e) {
      var t = S(e.clientY);
      null == i || i(t);
    },
    onSlideEnd: function onSlideEnd() {
      return f.current = void 0;
    },
    onStepKeyDown: function onStepKeyDown(e) {
      var t = p.ltr.includes(e.key);
      null == a || a({
        event: e,
        direction: t ? -1 : 1
      });
    }
  })));
}),
    _ = /*#__PURE__*/u.forwardRef(function (e, n) {
  var r = e.__scopeSlider,
      o = e.onSlideStart,
      i = e.onSlideMove,
      a = e.onSlideEnd,
      l = e.onHomeKeyDown,
      s = e.onEndKeyDown,
      p = e.onStepKeyDown,
      S = _objectWithoutProperties(e, _excluded4),
      h = b("Slider", r);
  /*#__PURE__*/


  /*#__PURE__*/
  return u.createElement(t.span, c({}, S, {
    ref: n,
    onKeyDown: d(e.onKeyDown, function (e) {
      "Home" === e.key ? (l(e), e.preventDefault()) : "End" === e.key ? (s(e), e.preventDefault()) : m.concat(f).includes(e.key) && (p(e), e.preventDefault());
    }),
    onPointerDown: d(e.onPointerDown, function (e) {
      var t = e.target;
      t.setPointerCapture(e.pointerId), e.preventDefault(), h.thumbs.has(t) ? t.focus() : o(e);
    }),
    onPointerMove: d(e.onPointerMove, function (e) {
      e.target.hasPointerCapture(e.pointerId) && i(e);
    }),
    onPointerUp: d(e.onPointerUp, function (e) {
      var t = e.target;
      t.hasPointerCapture(e.pointerId) && (t.releasePointerCapture(e.pointerId), a(e));
    })
  }));
});

export var SliderTrack = /*#__PURE__*/u.forwardRef(function (e, n) {
  var r = e.__scopeSlider,
      o = _objectWithoutProperties(e, _excluded5),
      i = b("SliderTrack", r);
  /*#__PURE__*/


  return u.createElement(t.span, c({
    "data-disabled": i.disabled ? "" : void 0,
    "data-orientation": i.orientation
  }, o, {
    ref: n
  }));
});
/*#__PURE__*/

export var SliderRange = /*#__PURE__*/u.forwardRef(function (e, n) {
  var _objectSpread2;

  var r = e.__scopeSlider,
      o = _objectWithoutProperties(e, _excluded6),
      i = b("SliderRange", r),
      a = y("SliderRange", r),
      d = u.useRef(null),
      s = l(n, d),
      m = i.values.length,
      f = i.values.map(function (e) {
    return K(e, i.min, i.max);
  }),
      p = m > 1 ? Math.min.apply(Math, _toConsumableArray(f)) : 0,
      S = 100 - Math.max.apply(Math, _toConsumableArray(f));
  /*#__PURE__*/


  return u.createElement(t.span, c({
    "data-orientation": i.orientation,
    "data-disabled": i.disabled ? "" : void 0
  }, o, {
    ref: s,
    style: _objectSpread(_objectSpread({}, e.style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, a.startEdge, p + "%"), _defineProperty(_objectSpread2, a.endEdge, S + "%"), _objectSpread2))
  }));
});
/*#__PURE__*/

export var SliderThumb = /*#__PURE__*/u.forwardRef(function (e, t) {
  var n = h(e.__scopeSlider),
      _u$useState5 = u.useState(null),
      _u$useState6 = _slicedToArray(_u$useState5, 2),
      r = _u$useState6[0],
      o = _u$useState6[1],
      i = l(t, function (e) {
    return o(e);
  }),
      a = u.useMemo(function () {
    return r ? n().findIndex(function (e) {
      return e.ref.current === r;
    }) : -1;
  }, [n, r]);
  /*#__PURE__*/


  return u.createElement(M, c({}, e, {
    ref: i,
    index: a
  }));
});

var M = /*#__PURE__*/u.forwardRef(function (e, r) {
  var o = e.__scopeSlider,
      i = e.index,
      a = _objectWithoutProperties(e, _excluded7),
      s = b("SliderThumb", o),
      m = y("SliderThumb", o),
      _u$useState7 = u.useState(null),
      _u$useState8 = _slicedToArray(_u$useState7, 2),
      f = _u$useState8[0],
      p = _u$useState8[1],
      h = l(r, function (e) {
    return p(e);
  }),
      v = n(f),
      w = s.values[i],
      g = void 0 === w ? 0 : K(w, s.min, s.max),
      x = function (e, t) {
    return t > 2 ? "Value ".concat(e + 1, " of ").concat(t) : 2 === t ? ["Minimum", "Maximum"][e] : void 0;
  }(i, s.values.length),
      E = null == v ? void 0 : v[m.size],
      R = E ? function (e, t, n) {
    var r = e / 2,
        o = T([0, 50], [0, r]);
    return (r - o(t) * n) * n;
  }(E, g, m.direction) : 0;

  return u.useEffect(function () {
    if (f) return s.thumbs.add(f), function () {
      s.thumbs.delete(f);
    };
  }, [f, s.thumbs]), /*#__PURE__*/u.createElement("span", {
    style: _defineProperty({
      transform: "var(--radix-slider-thumb-transform)",
      position: "absolute"
    }, m.startEdge, "calc(".concat(g, "% + ").concat(R, "px)"))
  }, /*#__PURE__*/u.createElement(S.ItemSlot, {
    scope: e.__scopeSlider
  }, /*#__PURE__*/u.createElement(t.span, c({
    role: "slider",
    "aria-label": e["aria-label"] || x,
    "aria-valuemin": s.min,
    "aria-valuenow": w,
    "aria-valuemax": s.max,
    "aria-orientation": s.orientation,
    "data-orientation": s.orientation,
    "data-disabled": s.disabled ? "" : void 0,
    tabIndex: s.disabled ? void 0 : 0
  }, a, {
    ref: h,
    style: void 0 === w ? {
      display: "none"
    } : e.style,
    onFocus: d(e.onFocus, function () {
      s.valueIndexToChangeRef.current = i;
    })
  }))));
}),
    P = function P(e) {
  var t = e.value,
      n = _objectWithoutProperties(e, _excluded8),
      o = u.useRef(null),
      i = r(t);

  return u.useEffect(function () {
    var e = o.current,
        n = window.HTMLInputElement.prototype,
        r = Object.getOwnPropertyDescriptor(n, "value").set;

    if (i !== t && r) {
      var _n3 = new Event("input", {
        bubbles: !0
      });

      r.call(e, t), e.dispatchEvent(_n3);
    }
  }, [i, t]), /*#__PURE__*/u.createElement("input", c({
    style: {
      display: "none"
    }
  }, n, {
    ref: o,
    defaultValue: t
  }));
};
/*#__PURE__*/


function K(e, t, n) {
  return 100 / (n - t) * (e - t);
}

function T(e, t) {
  return function (n) {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    var r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}

export var Root = Slider;
export var Track = SliderTrack;
export var Range = SliderRange;
export var Thumb = SliderThumb;